export const ENDPOINT = 'api/'
